// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const cadastrarRepresentante = async (representanteData: any) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/representante`;
    try {
      const response = await axios.post(URL, representanteData, {
        headers: { Authorization: Token.AuthStr },
      });

      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
};
